//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
(function () {
    'use strict';

    angular.module('container.widgets')
        .directive('srsngInputValidator', srsngInputValidator);

    function srsngInputValidator() {
        return {
            restrict: 'E',
            templateUrl: 'container/ui/app/widgets/input-validator/input-validator.html',
            scope: {
				updateon: '=',
                validate: '=',
                errors: '=',
                translationObject: '=',
                messages: '='
            },
            transclude: true,
            controller: controller,
            link: link
        };

        function controller($scope, $timeout) {
			$scope.iconColor = "icon-green";
            $scope.iconURL = "/container/ui/assets/img/icons/state-icons-18x18/state-ic-done-18x18.svg";
            $scope.scopeId = $scope.$id;
            $scope.popupVisible = false;
            $scope.errorMessages = [];
			$scope.updateonevents = "blur";
            $scope.translationObjectValue = {};
            if ($scope.translationObject){
                $scope.translationObjectValue = $scope.translationObject;
            }

			if($scope.updateon){
				$scope.updateonevents=$scope.updateon;
			}
            $scope.showPopup = function() {
                $timeout(function() {
                    $scope.popupVisible = $scope.errorMessages.length > 0;
                });
                setTimeout(function() {
                    $scope.popupVisible = false;
                }, 30000);
            };

            $scope.hidePopup = function() {
                $scope.popupVisible = false;
            }
        }

        function link(scope) {

            ['errors', 'validate'].forEach(key => {

                scope.$watch(key, v => {

                   if (scope.validate) {
                       setValidationData();
                       scope.hidePopup();
                       scope.showPopup();
                    } else {
                       scope.hidePopup();
                   }
                }, true);
            });

            function setValidationData() {

                scope.errorMessages = [];
                let errors = scope.errors;

                if (errors === undefined || Object.keys(errors).length === 0) {
                    scope.iconURL = "/container/ui/assets/img/icons/state-icons-18x18/state-ic-done-18x18.svg";
                    scope.iconColor = "icon-green";
                }
                else {
                    if (errors.required) {
                        scope.iconURL = "/container/ui/assets/img/icons/state-icons-18x18/state-ic-required-18x18.svg";
                        scope.iconColor = "icon-red";
                    }
                    else {
                        scope.iconURL = "/container/ui/assets/img/icons/state-icons-18x18/state-ic-error-18x18.svg";
                        scope.iconColor = "icon-red";
                    }

                    for (let prop in errors) {
                        if (errors.hasOwnProperty(prop) && errors[prop])
                            scope.errorMessages.push(scope.messages[prop]);
                    }
                }
            }
        }
    }
})();

